import * as React from 'react';
import PencilOutlined from './pencil-outlined';
import PencilFilled from './pencil-filled';
import type { IconCombinedProps } from './types';
const PencilCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PencilFilled ref={ref} {...rest} />;
  }
  return <PencilOutlined ref={ref} {...rest} />;
});
export default PencilCombined;